import { callNativeAsyncFunc, NativeFuncs } from "./mcAppJsSDK";

export const mcShare = params => callNativeAsyncFunc(NativeFuncs.SYSTEM.APP_SHARE, params);
